import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('../components/Login.vue')
    },
    {
      path: '/all-news',
      name: 'NewsAnnouncements',
      component: () => import('../components/NewsAnnouncements.vue')
    },
    {
      path: '/all-event',
      name: 'EventDeadlineDetailView',
      component: () => import('../components/EventDeadlineDetailView.vue')
    },
    {
      path: '/backend/list/newsannouncements',
      name: 'ListNewsAnnouncements',
      component: () => import('../components/backend/ListNewsAnnouncements.vue')
    },
    {
      path: '/backend/newsandannouncements/create',
      name: 'AddNews',
      component: () => import('../components/backend/NewsAddEdit.vue')
    },
    {
      path: '/backend/newsandannouncements/edit/:id',
      name: 'NewsEdit',
      component: () => import('../components/backend/NewsAddEdit.vue')
    },
    {
      path: '/backend/list/events',
      name: 'ListEvents',
      component: () => import('../components/backend/ListEvents.vue')
    },
    {
      path: '/backend/event/create',
      name: 'AddEvent',
      component: () => import('../components/backend/EventAddEdit.vue')
    },
    {
      path: '/backend/event/edit/:id',
      name: 'EventEdit',
      component: () => import('../components/backend/EventAddEdit.vue')
    },
    {
      path: '/backend/documents/:slug/create',
      name: 'DocumentAdd',
      component: () => import('../components/backend/DocumentAddEdit.vue')
    },
    {
      path: '/backend/documents/:slug/edit/:id',
      name: 'DocumentEdit',
      component: () => import('../components/backend/DocumentAddEdit.vue')
    },
    {
      path: '/backend/documents/:slug',
      name: 'BackendDocuments',
      component: () => import('../components/backend/Documents.vue')
    },
    {
      path: '/backend/list/users',
      name: 'ListUsers',
      component: () => import('../components/backend/ListUsers.vue')
    },
    {
      path: '/backend/user/edit/:id',
      name: 'UpdateUser',
      component: () => import('../components/backend/UpdateUser.vue')
    },
    {
      path: '/backend/list/reportproblemmails',
      name: 'ListReportProblemMail',
      component: () => import('../components/backend/ListReportProblemMail.vue')
    },
    {
      path: '/backend/list/opinionmattermails',
      name: 'ListOpinionMatterMail',
      component: () => import('../components/backend/ListOpinionMatterMail.vue')
    },
    {
      path: '/search/:search',
      name: 'Search',
      component: () => import('../components/Search.vue')
    },
    {
      path: '/policies',
      name: 'Policies',
      component: () => import('../components/FrontEndDocuments/Policy.vue')
    },
    {
      path: '/code-of-conduct',
      name: 'CodeofConduct',
      component: () => import('../components/FrontEndDocuments/CodeofConduct.vue')
    },
    {
      path: '/projects',
      name: 'Projects',
      component: () => import('../components/FrontEndDocuments/Projects.vue')
    },
    {
      path: '/ondemandtrainings',
      name: 'OnDemandTrainings',
      component: () => import('../components/FrontEndDocuments/OnDemandTraining.vue')
    },
    {
      path: '/event/:slug',
      name: 'EventDetails',
      component: () => import('../components/EventDetails.vue')
    },
    {
      path: '/news/:slug',
      name: 'NewsDetails',
      component: () => import('../components/NewsDetails.vue')
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('../components/Home.vue')
    },
    {
      path: '/backend/list/searchlogs',
      name: 'ListSearchLog',
      component: () => import('../components/backend/ListSearchLog.vue')
    },
    {
      path: '/backend/list/departments',
      name: 'DepartmentList',
      component: () => import('../components/Department.vue')
    },
    {
      path: '/backend/ondemandtrainings',
      name: 'ListOnDemandTrainings',
      component: () => import('../components/backend/OnDemandTrainings.vue')
    },
    {
      path: '/backend/ondemandtraining/create',
      name: 'OnDemandTrainingAdd',
      component: () => import('../components/backend/OnDemandTrainingAddEdit.vue')
    },
    {
      path: '/backend/ondemandtraining/edit/:id',
      name: 'OnDemandTrainingEdit',
      component: () => import('../components/backend/OnDemandTrainingAddEdit.vue')
    }
  ]
});

let appInstance;

// Define the function to set the app instance
function setAppInstance(instance) {
    appInstance = instance; // Assign the instance
}

// Navigation guard
router.beforeEach((to, from, next) => {
    if (appInstance) {
      appInstance.loading = true; // Set loading to true
    }
    next();
});

router.afterEach(() => {
    if (appInstance) {
      appInstance.loading = false; // Set loading to false
    }
});
export default router;
export { setAppInstance };



// WEBPACK FOOTER //
// ./src/router/index.js